export const base = {
  py: 0,
  px: ["s500", null, "s700"],
  mx: "auto",
  maxWidth: "base",
};

export const baseNoGutters = {
  variant: "layout.base",
  px: [0, null, 0],
};

// Theme UI uses container as our default.
export const container = {
  variant: "layout.base",
};

export const wide = {
  variant: "layout.base",
  maxWidth: "wide",
};

export const wideNoGutters = {
  variant: "layout.wide",
  px: [0, null, 0],
};

export const small = {
  variant: "layout.base",
  maxWidth: "small",
};

export const smallNoGutters = {
  variant: "layout.small",
  px: [0, null, 0],
};

export const account = {
  variant: "layout.base",
  px: "s200",
  maxWidth: "account",
};

export const content01 = {
  variant: "layout.base",
  maxWidth: "content01",
};

export const content01NoGutters = {
  variant: "layout.content01",
  px: [0, null, 0],
};

export const content02 = {
  variant: "layout.base",
  maxWidth: "content02",
};

export const content02NoGutters = {
  variant: "layout.content02",
  px: [0, null, 0],
};

export const content03 = {
  variant: "layout.base",
  maxWidth: "content03",
};

export const content03NoGutters = {
  variant: "layout.content03",
  px: [0, null, 0],
};

export const content04 = {
  variant: "layout.base",
  maxWidth: "content04",
};

export const content04NoGutters = {
  variant: "layout.content04",
  px: [0, null, 0],
};

export const content05 = {
  variant: "layout.base",
  maxWidth: "content05",
};

export const content05NoGutters = {
  variant: "layout.content05",
  px: [0, null, 0],
};
